import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { caseRouteSchema, caseSearchSchema } from '../../../../Utils/routeSchema';

export const Route = createFileRoute('/(main)/_layout/cases/_cases/$caseId')({
  params: {
    parse: (params) => caseRouteSchema.parse(params),
  },
  validateSearch: caseSearchSchema,
  beforeLoad: ({ location, params }) => {
    // Only inject sidebar=case when there is no other search params
    if (Object.keys(location.search).length === 0) {
      throw redirect({
        to: '.',
        params,
        search: {
          sidebar: 'case',
        },
        replace: true,
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  // route only registered to create path param, main outlet still renders cases list
  return <Outlet />;
}
